import { render, staticRenderFns } from "./vindicator.vue?vue&type=template&id=4866e142&"
import script from "./vindicator.vue?vue&type=script&lang=js&"
export * from "./vindicator.vue?vue&type=script&lang=js&"
import style0 from "./vindicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports